export const findMortgageRatesData = (articleBodyTemplate) => {
  if (!articleBodyTemplate) {
    return null
  }

  let mostRecentMortgageUpdateDate: Date | null = null

  const loopArticleBodyTemplate = (nodes: any[]) => {
    if (!Array.isArray(nodes)) {
      return
    }

    for (const node of nodes) {
      if (node && typeof node === 'object' && node.component === 'MortgageRates') {
        const lastUpdatedValue = node.props?.mortgageRatesData?.lastUpdated

        if (lastUpdatedValue) {
          const [date, time] = lastUpdatedValue.split(' ')
          const [day, month, year] = date.split('/')
          const [hours, minutes] = time.split(':')

          const currentUpdatedDate = new Date(
            Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hours), Number(minutes))
          )

          if (
            mostRecentMortgageUpdateDate === null ||
            currentUpdatedDate > mostRecentMortgageUpdateDate
          ) {
            mostRecentMortgageUpdateDate = currentUpdatedDate
          }
        }
      }

      if (node && node.children) {
        loopArticleBodyTemplate(node.children)
      }
    }
  }

  loopArticleBodyTemplate(articleBodyTemplate)
  return mostRecentMortgageUpdateDate
}
